import React from 'react'
import PropTypes from 'prop-types'
import ProductItem from './product-item'
import {
  NewProduct,
  ProductIcon,
  ProductTrash,
  ReservationProduct,
  UncategorizedProduct
} from './product-list-icons'
import Sortable from 'sortablejs'
import ConfirmationDialog from '../confirmation-dialog'
import ProductEditModal from '../../containers/shop/product-modal'
import GroupModal from '../group-modal'
import UncategorizedModal from './product/uncategorized-modal'

class ProductList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductGroup: null,
      productToDelete: null,
      openUncategorizedProduct: null
    }
  }

  onClickUncategorizedProduct() {
    this.setState({ openUncategorizedProduct: true })
  }

  deleteProduct = () => {
    this.props.onDeleteProduct(this.state.productToDelete.id)
    this.cancelDelete()
  }

  cancelDelete = () => this.setState({ productToDelete: null })

  cancelGroup = () => this.setState({ openProductGroup: null })

  onClickProduct = (id) => {
    const product = this.props.items[id]
    if (product.type === 'group') {
      this.setState({ openProductGroup: product })
    } else {
      this.closeProductGroup()
      this.props.onClickProduct(id)
    }
  }

  onAddUncategorizedProduct = (price) => {
    if (isNaN(price)) return
    this.setState({ openUncategorizedProduct: false })
    this.props.onClickUncategorizedProduct(price)
  }

  onClickEditGroup = () => {
    this.props.onClickProduct(this.state.openProductGroup.id)
    this.closeProductGroup()
  }

  closeProductGroup() {
    this.setState({ openProductGroup: null })
  }

  startDelete(product) {
    this.setState({ productToDelete: product })
  }

  filterItems(ids, query, result) {
    ids.forEach((id) => {
      if (this.props.items[id].childItemIds) {
        if (this.props.items[id].title.match(query)) result.push(id)
        this.filterItems(this.props.items[id].childItemIds, query, result)
      } else {
        if (this.props.items[id].title.match(query)) result.push(id)
      }
    })
    return result
  }

  renderProductItems(itemIds, limit) {
    if (limit == null) limit = itemIds.length
    const { items, showQuantityInStock, isSortable } = this.props
    return this.itemsToShow(itemIds)
      .slice(0, limit)
      .map((id) => (
        <ProductItem
          productId={id}
          products={items}
          key={id}
          showQuantityInStock={showQuantityInStock}
          isSortable={isSortable}
          onClick={this.onClickProduct}
        />
      ))
  }

  openCustomPayModal = () => {
    const firstOpenAlert = localStorage.getItem(`custom-pay-alert-shown`)
    if (!firstOpenAlert) {
      alert(
        `Custom pay allows you to create a transaction for any custom amount without assigning it to an item`
      )
      localStorage.setItem(`custom-pay-alert-shown`, true)
    }
    this.setState({ openUncategorizedProduct: true })
  }

  itemsToShow(itemIds) {
    if (!this.props.filter) return itemIds.filter((id) => id)

    var result = []
    var query = new RegExp(this.props.filter, 'i')
    return this.filterItems(itemIds, query, result)
  }

  render() {
    const {
      limit,
      sortedItemIds,
      canDelete,
      hasReservation,
      items,
      isSortable,
      showQuantityInStock,
      canAdd,
      onClickNewProduct,
      onClickPlus,
      onClickReservationProduct,
      onSortProducts,
      groupId,
      currency
    } = this.props
    const onClickEditGroup = showQuantityInStock ? this.onClickEditGroup : null
    const { openProductGroup, productToDelete } = this.state
    return (
      <div className="product-list">
        <div className="shop-products" ref={(e) => (this.domList = e)}>
          {this.renderProductItems(sortedItemIds, limit)}
          {hasReservation && (
            <ReservationProduct onClick={onClickReservationProduct} />
          )}
          {!groupId && (
            <UncategorizedProduct
              title={'Custom Pay'}
              onClick={this.openCustomPayModal}
            />
          )}
          {canAdd && <NewProduct onClick={onClickNewProduct} />}
          {canDelete && <ProductTrash refFunc={(e) => (this.domTrash = e)} />}
          {limit && limit < sortedItemIds.length && (
            <ProductIcon onClick={onClickPlus} icon="plus" title="More" />
          )}
        </div>
        {productToDelete && (
          <ConfirmationDialog
            onRequestClose={this.cancelDelete}
            onConfirm={this.deleteProduct}
          >
            Would you like to delete <b>{productToDelete.title}</b> from POS
            list?
          </ConfirmationDialog>
        )}
        {openProductGroup && (
          <GroupModal
            title={openProductGroup.title}
            onRequestClose={this.cancelGroup}
            onClickEdit={onClickEditGroup}
          >
            <ProductList
              groupId={openProductGroup.id}
              sortedItemIds={openProductGroup.childItemIds}
              isSortable={isSortable}
              items={items}
              currency={currency}
              onClickProduct={this.onClickProduct}
              onSortProducts={onSortProducts}
            />
          </GroupModal>
        )}

        <ProductEditModal currency={currency} />
        <UncategorizedModal
          isOpen={this.state.openUncategorizedProduct}
          onCancel={() => this.setState({ openUncategorizedProduct: false })}
          onConfirm={this.onAddUncategorizedProduct}
        />
      </div>
    )
  }

  componentDidMount() {
    if (!this.props.isSortable) return
    Sortable.create(this.domList, {
      group: { name: 'products', pull: 'clone' },
      draggable: '.shop-product.sortable',
      onUpdate: () => {
        const ids = Array.from(this.domList.children)
          .map((item) => parseInt(item.dataset.id))
          .filter((id) => id !== 0)
        this.props.onSortProducts(ids, this.props.groupId)
      }
    })
    if (this.props.canDelete) {
      Sortable.create(this.domTrash, {
        group: 'products',
        onAdd: (event) => {
          const element = event.item
          // start of dirty hack
          const clonedElement = Array.from(this.domList.children).find(
            (node) => node.dataset.id === element.dataset.id
          )
          this.domList.replaceChild(element, clonedElement)
          // end of dirty hack
          const product = this.props.items[element.dataset.id]
          this.startDelete(product)
        }
      })
    }
  }
}

ProductList.propTypes = {
  canDelete: PropTypes.bool,
  canAdd: PropTypes.bool,
  isSortable: PropTypes.bool,
  hasReservation: PropTypes.bool,
  showQuantityInStock: PropTypes.bool,

  filter: PropTypes.string,
  groupId: PropTypes.number,
  currency: PropTypes.string,
  items: PropTypes.object,
  limit: PropTypes.number,
  sortedItemIds: PropTypes.array.isRequired,

  onClickNewProduct: PropTypes.func,
  onClickPlus: PropTypes.func,
  onClickProduct: PropTypes.func,
  onClickReservationProduct: PropTypes.func,
  onDeleteProduct: PropTypes.func,
  onSortProducts: PropTypes.func
}

export default ProductList
